import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../service/server/server.service';
import Num2persian from 'num2persian';

@Component({
  selector: 'app-sale-invoice',
  templateUrl: './sale-invoice.component.html',
  styleUrls: ['./sale-invoice.component.scss']
})
export class SaleInvoiceComponent implements OnInit, OnDestroy {
  factor_type: number = 2;
  customer_address: string | undefined;
  customer_cellphone: number | undefined;
  public isOnline: any | undefined;
  public loading = false;
  user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public lang = JSON.parse(<any>localStorage.getItem('lang'));
  user_id: number | undefined;
  public subscription: Subscription | any;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  list_record: any = [];
  id: any | undefined;
  customer_title: string | undefined;
  customer_post_code: number | undefined;
  code_factor: number | undefined;
  date: string | undefined;
  list_national_id: any = [];
  list_economic_id: any = [];
  sum_all: number = 0;
  discount_all: number = 0;
  sum_all_letters: string | undefined;
  sum_after_discount: number = 0;
  sum_tax: number = 0;
  sum_all_after_tax: number = 0;
  hide: boolean = true;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , private activatedRoute: ActivatedRoute) {

  }//end consructor

  ngOnInit() {
    this.serverService.status1(2);
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.id = params['id'];
      }
    )
    this.get_customer();
  }

  hide_invoice_number() {
    this.hide = !this.hide;
  }

  get_customer() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10644, id: this.id }).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.list_national_id = [];
            this.list_economic_id = [];
            this.customer_title = res['result'][0].user_title;
            this.customer_address = res['result'][0].user_address;
            this.customer_cellphone = res['result'][0].user_cellphone;
            this.customer_post_code = res['result'][0].user_post_code;
            this.code_factor = res['result'][0].pre_factor_lsf_order_code_factor;
            this.date = res['result'][0].pre_factor_lsf_order_date;
            this.discount_all = res['result'][0].pre_factor_lsf_order_discount_all;
            if (res['result'][0].user_national_id) {
              var x = res['result'][0].user_national_id.split('');
              for (var i = 0; i < x.length; i++) {
                this.list_national_id.unshift(x[i])
              }
            }
            if (res['result'][0].user_economic_id) {
              var x = res['result'][0].user_economic_id.split('');
              for (var i = 0; i < x.length; i++) {
                this.list_economic_id.unshift(x[i])
              }
            }
            this.get_material();
          }

        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_material() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10621, id: this.id }).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][i].wharehouse_order_cost > 0) {
              res['result'][i].sum_after_tax = res['result'][i].sum - res['result'][i].wharehouse_order_discount + res['result'][i].tax;
              this.sum_after_discount += res['result'][i].sum - res['result'][i].wharehouse_order_discount;
              if (res['result'][i].wharehouse_material_id == 433) {

              }
              this.sum_all += res['result'][i].sum - res['result'][i].wharehouse_order_discount;
              this.sum_tax += res['result'][i].tax;
              this.list_record.push(res['result'][i]);
            }
          }//end for
          this.sum_all_after_tax = this.sum_all + this.sum_tax;

          this.sum_all_letters = Num2persian(this.sum_all_after_tax)
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 5000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}

